import { axios } from 'lib'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'

export const approveProposal = async (id: string): Promise<any> => {
  return axios.post(`/orders/proposals/${id}/approve`)
}

type Params = {
  onSuccess: (data?: unknown) => void
}

export function useApproveProposal({ onSuccess }: Params) {
  const queryClient = useQueryClient()
  return useMutation(approveProposal, {
    onSuccess: () => {
      queryClient.invalidateQueries('orders')
      queryClient.invalidateQueries('orderActions')
      toast.success('Orçamento aprovado com sucesso!')
      onSuccess?.()
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error('Não foi possível aprovar o orçamento!')
    }
  })
}
